export const getFileExtension = (filepath) => {
  if (!filepath || !filepath.length) return null;

  return filepath.split('.').pop().toLowerCase();
};

// used to avoid eslint error about default export as there
// might be more functions in the future
export const _ = () => null;
